import { Box, Typography } from "@mui/material";
import type { StockStatus } from "./productDrawerFormatting";
import { STOCK_STATUS_CONFIG, srOnlySx } from "./productDrawerFormatting";

export { srOnlySx };

export function StockDot({
  status,
  label,
  size = 8,
  showLabel = true,
  reverse = false,
}: {
  status: StockStatus;
  label: string;
  size?: number;
  showLabel?: boolean;
  reverse?: boolean;
}) {
  const { dotColor } = STOCK_STATUS_CONFIG[status];
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        flexShrink: 0,
        flexDirection: reverse ? "row-reverse" : "row",
        position: "relative",
      }}
    >
      <Box component="span" sx={srOnlySx}>
        Stock status:
      </Box>
      <Box
        aria-hidden="true"
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          bgcolor: dotColor,
          flexShrink: 0,
        }}
      />
      <Typography
        component="span"
        variant="caption"
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: "text.primary",
          opacity: showLabel ? 1 : 0,
          transition: "opacity 0.15s ease",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
